import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;

  .canvas {
    width: 100%;
    height: 100%;
  }
`;

export const MuteButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background-size: 100%;
  z-index: 3;
  pointer-events: all;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 0 0 0 #fff;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0 0 2px #fff;
  }
`;
